module.exports = flarum.core.compat['flags/components/FlagList'];